import React, { useState, useRef, useMemo } from "react";
import { Row, Form } from "react-bootstrap";
import { apiHelper } from "../lib/ApiHelper";
import "./Landing.css";
import "./imprintTitle.css";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import PRHLoader from "../lib/PRHLoader";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    RangeSelectionModule,
]);
import { LicenseManager } from "@ag-grid-enterprise/core";


LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");
export default function ImprintPopUp(props) {
    const [message, setMessage] = useState('');
    const [updatemessage, setupdatemessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError2, setIsError2] = useState(false);
    const [updatedAssignment, setUpdatedAssignment] = useState([]);
    const [Currentassignment, setCurrentassignment] = useState([]);
    const [gridOptions, setGridOptions] = useState({
        defaultColDef: {
            resizable: true,
            sortable: true,
            filter: true,
            flex: 1,
        },
        debounceVerticalScrollbar:true,
        alwaysShowHorizontalScroll: true,
        pagination: true,
        paginationPageSizeSelector: { paginationPageSizeSelector },
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        paginationPageSize: 5,
        animateRows: true,
        accentedSort: true,
        overlayNoRowsTemplate: '<span class="ag-overlay-no-rows-center">No records found.</span>',
    });

    const paginationPageSizeSelector = useMemo(() => {
        return [5, 10, 20, 30];
    }, []);

    const handleDownloadTemplate = () => {
        const link = document.createElement('a');
        link.href = `${process.env.PUBLIC_URL}/static/template/ownership-assignments-template.csv`;
        link.download = 'ownership-assignments-template.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const columnDefs = [
        { headerName: "Owner Name", field: "ownerName", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        { headerName: "Owner UPN", field: "ownerUPN", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        { headerName: "Division", field: "division", headerClass: "HeaderClassSource header-text-right", cellClass: "cell-text-right" },
        { headerName: "Division Desc", field: "divisionDesc", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        { headerName: "Imprint", field: "imprint", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        { headerName: "Imprint Desc", field: "imprintDesc", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        { headerName: "Product Line", field: "productLine", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        { headerName: "Product Line Desc", field: "productLineDesc", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        {
            headerName: "",
            field: "",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource ml-4",
            cellRenderer: (params) => {
                return <div>
                    <button className="ImprintActionBut" onClick={() => handleDelete(params.data)}>Delete</button>
                </div >;
            }, cellClass: "cell-text-left ml-1"
        }
    ];

    const columnDefsChanges = [
        { headerName: "Owner Name", field: "ownerName", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        { headerName: "Owner UPN", field: "ownerUPN", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        {
            headerName: "Division", field: "division", headerClass: "HeaderClassSource header-text-right", cellClass: "cell-text-right", editable: (params) => params.data.action != "D",  // Enable editing,
            cellEditor: "agTextCellEditor",
            onCellValueChanged: (params) => { handleCellValueChanged(params) },// Add event handler
        },
        { headerName: "Division Desc", field: "divisionDesc", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        {
            headerName: "Imprint", field: "imprint", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1", editable: (params) => params.data.action != "D",  // Enable editing
            cellEditor: "agTextCellEditor",
            onCellValueChanged: (params) => { handleCellValueChanged(params) },// Add event handler
        },
        { headerName: "Imprint Desc", field: "imprintDesc", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },
        {
            headerName: "Product Line", field: "productLine", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1", editable: (params) => params.data.action != "D", // Enable editing
            cellEditor: "agTextCellEditor",
            onCellValueChanged: (params) => { handleCellValueChanged(params) },// Add event handler
        },

        { headerName: "Product Line Desc", field: "productLineDesc", headerClass: "HeaderClassSource", cellClass: "cell-text-left ml-1" },

        {
            headerName: "New Owner UPN",
            field: "newOwnerUPN",  // Assign the correct field for editing
            editable: (params) => params.data.action != "D", // Simplified arrow function
            cellEditor: "agTextCellEditor",
            cellEditorParams: {
                placeholder: "Enter new owner UPN" // Add placeholder
            },
            onCellValueChanged: (params) => {
                const newValue = params.newValue.toLowerCase();
                params.data.newOwnerUPN = newValue;
                gridApichanges.current.refreshCells({
                    rowNodes: [params.node], force: true
                });
            },
            cellClassRules: {
                "error": (params) => {
                    return !validateEmail(params.data.newOwnerUPN);
                }
            },
            tooltipValueGetter: (params) => {
                if (!params.value) {
                    return "Enter new owner UPN";
                } else if (!validateEmail(params.value)) {
                    return "Please provide valid email address.";
                }
                return null;
            },
            headerClass: "HeaderClassSource"
            , cellClass: "cell-text-left ml-2"
        },
        {
            headerName: "",
            field: "",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left ml-3",
            cellRenderer: (params) => {
                return (
                    <div>
                        {params.data.action === "D" ? (
                            <button className="ImprintActionBut" onClick={() => handleRemove(params.data)}>
                                Remove
                            </button>
                        ) : (
                            <button className="ImprintActionBut" onClick={() => handleDuplicate(params.data)}>
                                Duplicate
                            </button>
                        )}
                    </div>
                );
            }
        },
        {
            headerName: "Action",
            field: "",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left  ml-1",
            cellRenderer: (params) => {
                return (
                    <div>
                        {params.data.action === 'D' ? "Delete" : (validateEmail(params.data.newOwnerUPN) ? "Insert" : "No Action")}
                    </div>
                );
            }
        }
    ];


    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@(dk\.com|penguinrandomhouse\.com|prh\.com)$/;
        return emailRegex.test(email);
    };

    const handleRemove = (data) => {
        setUpdatedAssignment(prevData => {
            const updatedData = [];
            let removedRow = null;

            for (const item of prevData) {
                if (
                    item.division === data.division &&
                    item.imprint === data.imprint &&
                    item.ownerUPN === data.ownerUPN &&
                    item.productLine === data.productLine
                ) {
                    removedRow = { ...item };
                    delete removedRow.newOwnerUPN;
                    delete removedRow.action;
                } else {
                    updatedData.push(item);
                }
            }
            if (removedRow) {
                setCurrentassignment(prev => [...prev, removedRow]);
            }
            return updatedData; // Update UpdatedAssignment
        });
    };


    const handleDuplicate = (data) => {
        const duplicatedItem = { ...data, newOwnerUPN: "" }; // Assign a new ID to avoid key conflicts
        setUpdatedAssignment(prev => [...prev, duplicatedItem])
    };

    const gridApi = useRef(null);
    const gridApichanges = useRef(null);

    const onGridReadyChanges = async (params) => {
        gridApichanges.current = params.api;
    };

    const handleDelete = (data) => {
        const updatedData = [];
        const deletedRow = [];

        Currentassignment.forEach(item => {
            if (item === data) {
                deletedRow.push({ ...item, action: "D" });// Only push to deletedRow if it's the item to be deleted
            } else {
                updatedData.push(item);  // Otherwise, push to updatedData
            }
        });
        setCurrentassignment(updatedData);
        setUpdatedAssignment(prev => [...prev, ...deletedRow]);
    }

    const onclose = () => {
        props.onClose();
    }
    const update = async () => {
        try {
            if (updatedAssignment != null && updatedAssignment.length > 0) {
                // Validate email addresses
                const invalidRows = updatedAssignment.filter(item => item.action !== "D" && (item.newOwnerUPN && item.newOwnerUPN.trim() != "" && !validateEmail(item.newOwnerUPN)));
                if (invalidRows.length > 0) {
                    setIsError2(true);
                    setupdatemessage("Some rows have invalid email addresses. Please correct them before updating.");
                    return;
                }
                // Filter rows with either valid email in newOwnerUPN or action is "D"
                const validRows = updatedAssignment.filter(item => validateEmail(item.newOwnerUPN) || item.action === "D");
                // Proceed with the update if validation passes
                if (validRows.length > 0) {
                    const data = await apiHelper.inventoryPostCall("manageImprint", validRows);
                    if (data && data.status !== 500) {
                        setupdatemessage("Data Updated Successfully");
                        getVisuals();
                    } else {
                        setIsError2(true);
                        setupdatemessage("Error in updating data");
                    }
                } else {
                    setIsError2(true);
                    setupdatemessage("Please select a row");
                }
            } else {
                setIsError2(true);
                setupdatemessage("No records available");
            }
        } catch {
            setIsError2(true);
            setupdatemessage("Error in updating data");
        } finally {
            setTimeout(() => (setupdatemessage(''), setIsError2(false)), 3000);
            refreshFilter();
        }
    };

    const refreshFilter = () => {
        if (gridApi.current) {
            gridApi.current.setFilterModel(null);
        }
        if (gridApichanges.current) {
            gridApichanges.current.setFilterModel(null);
        };
    }

    const onGridReady = async (params) => {
        gridApi.current = params.api;
    };

    const handleFileUpload = async (event) => {
        setIsLoading(true);
        const fileInput = event.target;
        const file = fileInput.files[0];

        try {
            if (file) {
                const response = await apiHelper.uploadImprint(file);
                if (response && response.success) {
                    const { commonImprint, uniqueImprint, message } = response.data;
                    if (commonImprint && uniqueImprint) {
                        setCurrentassignment(commonImprint);
                        setUpdatedAssignment(uniqueImprint);
                        setIsError(false);
                        setMessage(message || "File uploaded successfully.");
                    } else {
                        setCurrentassignment([]);
                        setUpdatedAssignment([]);
                        setIsError(true);
                        setMessage("Unexpected response format from the server.");
                    }
                } else {
                    setIsError(true);
                    setMessage(response?.message || "Error occurred while uploading the file.");
                }
            } else {
                setIsError(true);
                setMessage("No file selected for upload.");
            }
        } catch (error) {
            setIsError(true);
            setMessage("An error occurred while processing the file upload.");
        } finally {
            setIsLoading(false);
            fileInput.value = ""; // Reset file input
            setTimeout(() => {
                setMessage("");
                setIsError(false);
            }, 3000);
            refreshFilter();
            document.getElementById('ProductLine').value = "";
            document.getElementById('Imprint').value = "";
            document.getElementById('Division').value = "";
        }
    };



    const handleCellValueChanged = async (params) => {
        const { data, colDef, newValue } = params;
        const field = colDef.field;
        // Update the respective field with the new value
        data[field] = newValue && newValue.trim() !== ''
            ? newValue.trim().toUpperCase()
            : null; // or '' or undefined, based on your requirement

        // Search for related data in the unique list, excluding the current row
        const match = updatedAssignment.find(item =>
            item.division === data.division &&
            item.imprint === data.imprint &&
            item.productLine === data.productLine &&
            item !== data
        );
        if (match) {
            // Update the respective description if found
            data.divisionDesc = match.divisionDesc;
            data.imprintDesc = match.imprintDesc;
            data.productLineDesc = match.productLineDesc;
        } else {
            // If not found, call getImprints to search for the related data
            const res = await apiHelper.inventoryPostCall("getImprintEdits", updatedAssignment);
            if (res && res.commonImprint) {
                setCurrentassignment(res.commonImprint);
            }
            if (res && res.uniqueImprint) {
                setUpdatedAssignment(res.uniqueImprint);
            }
        }
        // Refresh the grid to reflect the changes
        gridApichanges.current.refreshCells({ rowNodes: [params.node], force: true });
    };

    async function getVisuals() {

        const ProductLines = document.getElementById('ProductLine')?.value?.trim().toUpperCase() || "";
        const Imprints = document.getElementById('Imprint')?.value?.trim().toUpperCase() || "";
        const Divisions = document.getElementById('Division')?.value?.trim().toUpperCase() || "";

        document.getElementById('ProductLine').value = ProductLines;
        document.getElementById('Imprint').value = Imprints;
        document.getElementById('Division').value = Divisions;

        if (ProductLines != "" || Imprints != "" || Divisions != "") {
            let currentAssign = await apiHelper.inventoryPostCall("getImprints", [{ Imprint: Imprints == "" ? null : Imprints, ProductLine: ProductLines == "" ? null : ProductLines, Division: Divisions == "" ? null : Divisions }]);
            if (currentAssign != null) {
                setCurrentassignment(currentAssign.commonImprint);
                setUpdatedAssignment(currentAssign.uniqueImprint);
                setMessage("");
                setIsError(false);
            } else {
                setMessage("Some error occured while fetching data");
                setIsError(true);
            }
        } else {
            if (updatedAssignment.length > 0) {
                const uniqueAssignments = updatedAssignment.reduce((acc, item) => {
                    if (!acc.some(existing => existing.division === item.division && existing.imprint === item.imprint && existing.productLine === item.productLine)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);

                let currentAssign = await apiHelper.inventoryPostCall("getImprints", uniqueAssignments);
                if (currentAssign != null) {
                    setCurrentassignment(currentAssign.commonImprint);
                    setUpdatedAssignment(currentAssign.uniqueImprint);
                    setMessage("");
                    setIsError(false);
                } else {
                    setMessage("Some error occurred while fetching data");
                    setIsError(true);
                }
            } else {
                setCurrentassignment([]);
                setUpdatedAssignment([]);
                setMessage("Please provide search.");
                setIsError(true);
            }
        }
        refreshFilter();
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            getVisuals();
        }
    };

    return (
        <div className="popup-overlay container-fluid visualImprint">
            <div className="srch-popup" style={{ overflowY: "hidden" }}><button className="popup-close-btn" onClick={onclose}></button>
                <div className="search-popup-content pt-2" style={{ overflowY: "auto" }}>
                    <div className="search-input-nav d-flex">
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label><div className="search-title-box">
                                <span className="header-imprint" >Ownership Assignments</span>
                            </div>
                            </Form.Label><br />
                            <Form.Label><div className="search-title-box">
                                <span className="title">Search</span>
                            </div>
                            </Form.Label><br />
                            <table >
                                <tr>
                                    <td>
                                        <Form.Group className="inputBox">
                                            <Form.Label className="sub-title">Division</Form.Label>
                                            <input id="Division" maxLength={2} onKeyDown={handleKeyDown}></input>
                                        </Form.Group>
                                    </td>
                                    <td>
                                        <Form.Group className="inputBox">
                                            <Form.Label className="sub-title" >Imprint</Form.Label>
                                            <input id="Imprint" maxLength={4} onKeyDown={handleKeyDown}></input>
                                        </Form.Group>
                                    </td>
                                    <td>
                                        <Form.Group className="inputBox">
                                            <Form.Label className="sub-title">Product Line</Form.Label>
                                            <input id="ProductLine" maxLength={3} onKeyDown={handleKeyDown}></input>
                                        </Form.Group>
                                    </td>
                                    <td>&nbsp;</td>
                                    <td style={{ width: "100%", paddingLeft: "20px" }}>
                                        <table>
                                        <tbody>
                                            <tr>
                                                <td colSpan="3">
                                                    {isLoading ? < PRHLoader /> : < span className={isError ? "imprint-vis-err  ml-1" : "imprint-vis-succ ml-1"} style={{ width: "100%" }}>{message}&nbsp;</span>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >  <button className="ISBNSubmit ml-0 mr-1" onClick={getVisuals}>Search</button></td>
                                                <td style={{ display: "block" }}>
                                                    <button className="ISBNSubmit mr-1" onClick={() => document.getElementById('fileUpload').click()}>Upload</button>
                                                    <input
                                                        type="file"
                                                        id="fileUpload"
                                                        accept=".csv"
                                                        style={{ display: 'none' }}
                                                        onChange={handleFileUpload}
                                                    />
                                                </td>
                                                <td style={{ paddingLeft: "20px" }}>
                                                    <span className="download-link" onClick={handleDownloadTemplate}>Download Template</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </Form.Group>
                    </div>
                    < div className="ag-theme-balham" style={{ width: "100%" }}>
                        <span className="title" style={{ marginBottom: "2px" }} >Changes</span>
                        <AgGridReact
                            rowData={updatedAssignment}
                            columnDefs={columnDefsChanges}
                            paginationPageSizeSelector={paginationPageSizeSelector}
                            domLayout="autoHeight"
                            gridOptions={gridOptions}
                            onGridReady={onGridReadyChanges}
                        />
                    </div>
                    <Row className="action-bar alerts" style={{ marginLeft: "auto", marginRight: "auto", display: "grid", paddingBottom: "15px" }}>
                        <div>
                            <span className={isError2 ? "imprint-vis-err" : "imprint-vis-succ"}>{updatemessage} &nbsp;</span>
                        </div>
                    </Row>
                    <Row className="action-bar mb-2" style={{ marginLeft: "auto", marginRight: "auto", display: "grid" }}>
                        <div>
                            <button className="ISBNSubmit note-button-width ml-1" style={{ position: "relative" }} onClick={update}>Update</button>
                            <button className="ISBNSubmit note-button-width ml-5" style={{ position: "relative" }} onClick={onclose}
                            >Close</button>
                        </div>
                    </Row>
                    <br />
                    <div className="ag-theme-balham" style={{ width: "100%" }}>
                        <span className="title" style={{ marginBottom: "2px" }} >Current Assignment</span>
                        <AgGridReact
                            rowData={Currentassignment}
                            paginationPageSizeSelector={paginationPageSizeSelector}
                            columnDefs={columnDefs}
                            gridOptions={gridOptions}
                            domLayout="autoHeight"
                            onGridReady={onGridReady}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}